(() => {
  class StoreLocatorPage {
    constructor(root) {
      this.root = root;

      this.mapEl = root.querySelector('[data-page-map]');
      this.listEl = root.querySelector('[data-page-list]');
      this.countEl = root.querySelector('[data-page-count]');
      this.searchEl = root.querySelector('[data-page-search]');
      this.sheet = root.querySelector('[data-page-sheet]');

      this.radius = 10;
      this.center = null;

      this.context = this.readContext();

      this.stores = window.ShasaStoreLocator.getStores();
      this.visibleStores = this.stores;
      this.searchTimer = null;

      this.markers = [];

      this.activeStoreCode = this.context.store || null;
      this.favoriteStoreCode = null;

      this.init();
    }



    readContext() {
      const params = new URLSearchParams(window.location.search);

      const lat = Number.parseFloat(params.get('lat'));
      const lng = Number.parseFloat(params.get('lng'));

      return {
        mode: params.get('mode') || '',
        postalCode: params.get('postal_code') || '',
        state: params.get('state') || '',
        store: params.get('store') || '',

        lat: Number.isFinite(lat) ? lat : null,
        lng: Number.isFinite(lng) ? lng : null
      };
    }

    async init() {
      await this.waitForGoogle();

      this.map = new google.maps.Map(
        this.mapEl,
        {
          center: {
            lat: 19.432608,
            lng: -99.133209
          },
          zoom: 10,
          mapTypeControl: true,
          streetViewControl: false,
          fullscreenControl: false
        }
      );

      /*
       * Recuperar la tienda favorita real
       * antes de pintar la lista.
       */
      if (
        window.ShasaStoreLocatorConfig
          ?.customerId &&
        window.ShasaStoreLocator
          ?.getFavoriteStore
      ) {
        try {
          const favorite =
            await window.ShasaStoreLocator
              .getFavoriteStore();

          if (favorite?.storeCode) {
            this.favoriteStoreCode =
              favorite.storeCode;
          }
        } catch (error) {
          console.warn(
            '[StoreLocatorPage] Could not load favorite store:',
            error
          );
        }
      }

      this.bind();

      await this.applyContext();

      this.enableMobileSheet();
    }

    waitForGoogle() {
      if (window.google?.maps) {
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        const timer = window.setInterval(() => {
          if (window.google?.maps) {
            window.clearInterval(timer);
            resolve();
          }
        }, 50);
      });
    }

    normalizeSearch(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase();
    }

  fitToRadius(center, radiusKm = 10) {
    if (!center || !this.map) return;

    const circle = new google.maps.Circle({
      center,
      radius: radiusKm * 1000
    });

    const bounds = circle.getBounds();

    if (!bounds) return;

    this.map.fitBounds(bounds, 40);
  }

  bind() {
    /*
* SEARCH
*
* - Busca en automático a partir de 5 caracteres, 500 ms después de la última tecla.
* - Enter ejecuta inmediatamente, con cualquier longitud.
*/
    this.searchEl?.addEventListener('input', () => {
      window.clearTimeout(this.searchTimer);

      const query = this.searchEl.value.trim();

      if (query.length < 5) {
        return;
      }

      this.searchTimer = window.setTimeout(async () => {
        try {
          await this.searchLocation(query);
        } catch (error) {
          console.error('[StoreLocatorPage] Search failed:', error);
        }
      }, 500);
    });

    this.searchEl?.addEventListener('keydown', async (event) => {
      if (event.key !== 'Enter') return;

      event.preventDefault();

      // Evita que se vuelva a ejecutar con el temporizador.
      window.clearTimeout(this.searchTimer);

      try {
        await this.searchLocation(this.searchEl.value);
      } catch (error) {
        console.error('[StoreLocatorPage] Search failed:', error);
      }
    });

    /*
     * RADIUS
     */
    this.root
      .querySelectorAll('input[name="store-radius"]')
      .forEach((input) => {
        input.addEventListener('change', () => {
          this.radius = Number(input.value);

          if (!Number.isFinite(this.radius)) {
            this.radius = 10;
          }

          this.applyRadius(true);
        });
      });

    /*
     * GEOLOCATION
     */
    this.root
      .querySelector('[data-page-geolocate]')
      ?.addEventListener('click', async (event) => {
        event.preventDefault();

        try {
          this.center =
            await window.ShasaStoreLocator.requestUserLocation();

          this.applyRadius(true);
        } catch (error) {
          console.error(
            '[StoreLocatorPage] Geolocation failed:',
            error
          );
        }
      });

    /*
     * STORE LIST
     */
    this.listEl?.addEventListener('click', (event) => {
      const card = event.target.closest('[data-store-code]');

      if (!card) return;

      const code = card.dataset.storeCode;

      if (!code) return;

      if (event.target.closest('[data-choose-store]')) {
        this.chooseStore(code);
        return;
      }

      this.selectStore(code);
    });
  }

    async applyContext() {
    /*
     * STORE
     */
    if (this.context.store) {
      const store = this.stores.find(
        (item) =>
          item.storeCode === this.context.store
      );

      if (store) {
        this.visibleStores = this.stores;

        this.activeStoreCode =
          store.storeCode;

        this.render(false);

        this.map.setCenter({
          lat: store.latitude,
          lng: store.longitude
        });

        this.map.setZoom(13);

        this.renderList();

        this.listEl
          ?.querySelector(
            `[data-store-code="${CSS.escape(
              store.storeCode
            )}"]`
          )
          ?.scrollIntoView({
            behavior: 'auto',
            block: 'nearest'
          });

        return;
      }
    }

    /*
     * STATE
     */
    if (
      this.context.mode === 'state' &&
      this.context.state
    ) {
      this.visibleStores =
        window.ShasaStoreLocator.storesByState(
          this.context.state
        );

      this.center = null;

      this.render(true);

      return;
    }

    /*
     * LAT / LNG
     *
     * Normalmente viene desde:
     * - postal code
     * - geolocation
     */
    if (
      Number.isFinite(this.context.lat) &&
      Number.isFinite(this.context.lng)
    ) {
      this.center = {
        lat: this.context.lat,
        lng: this.context.lng
      };

      /*
       * Si venimos de CP, dejamos el CP visible
       * en el buscador.
       */
      if (
        this.context.mode === 'postal' &&
        this.context.postalCode &&
        this.searchEl
      ) {
        this.searchEl.value =
          this.context.postalCode;
      }

      this.applyRadius(true);

      return;
    }

    /*
     * DEFAULT
     */
    this.visibleStores = this.stores;

    this.render(true);
  }

    async searchLocation(query) {
    const value = String(query || '').trim();

    // Si llega una búsqueda más nueva mientras Google responde, ignoramos la anterior.
    const requestId = (this.searchRequestId || 0) + 1;
    this.searchRequestId = requestId;

    if (!value) {
      this.visibleStores = this.center
        ? window.ShasaStoreLocator.storesNear(
          this.center,
          this.radius
        )
        : this.stores;

      this.render(false);

      return;
    }

    const normalizedQuery =
      this.normalizeSearch(value);

    /*
     * 1. Exact match contra tienda
     *
     * Esto permite:
     * "Shasa Perisur"
     * "CDMX, PERISUR"
     * "T016"
     */
    const exactStore = this.stores.find(
      (store) => {
        const candidates = [
          store.storeCode,
          store.name,
          store.displayName
        ]
          .filter(Boolean)
          .map((item) =>
            this.normalizeSearch(item)
          );

        return candidates.includes(
          normalizedQuery
        );
      }
    );

    if (exactStore) {
      this.center = {
        lat: exactStore.latitude,
        lng: exactStore.longitude
      };

      this.applyRadius(true);

      this.selectStore(
        exactStore.storeCode,
        false
      );

      return;
    }

    /*
     * 2. Google Geocoder
     *
     * Ciudad:
     * "Cuernavaca"
     *
     * Colonia:
     * "Narvarte"
     *
     * CP:
     * "03100"
     *
     * Dirección:
     * "Av Universidad 1000"
     */
    if (!window.google?.maps?.Geocoder) {
      throw new Error(
        'GOOGLE_GEOCODER_NOT_AVAILABLE'
      );
    }

    const geocoder =
      new google.maps.Geocoder();

    const response =
      await geocoder.geocode({
        address: `${value}, México`,
        componentRestrictions: {
          country: 'MX'
        }
      });

    if (requestId !== this.searchRequestId) return;

    if (!response.results?.length) {
      this.visibleStores = [];
      this.render(false);

      return;
    }

    const result = response.results[0];

    const location =
      result.geometry?.location;

    if (!location) {
      this.visibleStores = [];
      this.render(false);

      return;
    }

    this.center = {
      lat: location.lat(),
      lng: location.lng()
    };

    this.activeStoreCode = null;

    this.applyRadius(true);
  }

  /*
   * Local text filtering.
   *
   * Lo dejamos disponible por si después quieres
   * implementar suggestions/autocomplete sobre
   * las tiendas ya cargadas.
   */
  applyTextSearch() {
    const query =
      this.searchEl?.value || '';

    const base = this.center
      ? window.ShasaStoreLocator.storesNear(
        this.center,
        this.radius
      )
      : this.stores;

    this.visibleStores =
      window.ShasaStoreLocator.searchStores(
        query,
        base
      );

    this.render(false);
  }

  applyRadius(recenter = false) {
    if (!this.center) return;

    this.visibleStores =
      window.ShasaStoreLocator.storesNear(
        this.center,
        this.radius
      );

    this.render(false);

    if (recenter) {
      this.fitToRadius(
        this.center,
        this.radius
      );
    }
  }

  render(fit = true) {
    this.renderList();
    this.renderMarkers(fit);

    if (this.countEl) {
      const count =
        this.visibleStores.length;

      this.countEl.textContent =
        `${count} tienda${count === 1 ? '' : 's'
        } encontrada${count === 1 ? '' : 's'
        }`;
    }
  }

  renderList() {
    if (!this.listEl) return;

    const logged = Boolean(
      window.ShasaStoreLocatorConfig?.customerId
    );

    if (!this.visibleStores.length) {
      this.listEl.innerHTML = `
      <div class="store-page__empty">
        <p>
          No encontramos tiendas dentro de ${this.radius} km.
        </p>
      </div>
    `;

      return;
    }

    this.listEl.innerHTML = this.visibleStores
      .map((store) => {
        const isActive =
          store.storeCode === this.activeStoreCode;

        const isFavorite =
          store.storeCode === this.favoriteStoreCode;

        const address = [
          store.address1,
          store.municipality,
          store.state
        ]
          .filter(Boolean)
          .join(', ');

        const distance =
          Number.isFinite(store.distanceKm)
            ? `
            <p class="store-page__distance">
              ${store.distanceKm.toFixed(1)} km
            </p>
          `
            : '';

        let actionMarkup = '';

        /*
         * Favorita real guardada.
         */
        if (logged && isFavorite) {
          actionMarkup = `
          <div class="store-page__selected-state">
            ✓ TIENDA SELECCIONADA
          </div>
        `;
        }

        /*
         * Card activa pero todavía NO guardada.
         */
        else if (logged && isActive) {
          actionMarkup = `
          <button
            type="button"
            class="store-page__select"
            data-choose-store
          >
            Elegir esta tienda
          </button>
        `;
        }

        return `
        <article
          class="
            store-page__card
            ${isActive ? 'is-active' : ''}
            ${isFavorite ? 'is-favorite' : ''}
          "
          data-store-code="${store.storeCode}"
        >
          <div class="store-page__card-header">
            <h3>
              ${store.displayName}
            </h3>

            ${distance}
          </div>

          ${address
            ? `
                <p class="store-page__address">
                  ${address}
                </p>
              `
            : ''
          }

          ${actionMarkup
            ? `
                <div class="store-page__card-actions">
                  ${actionMarkup}
                </div>
              `
            : ''
          }
        </article>
      `;
      })
      .join('');
  }

  renderMarkers(fit = true) {
    if (!this.map) return;

    this.markers.forEach((marker) => {
      marker.setMap(null);
    });

    this.markers = [];

    const bounds =
      new google.maps.LatLngBounds();

    this.visibleStores.forEach(
      (store) => {
        if (
          !Number.isFinite(
            store.latitude
          ) ||
          !Number.isFinite(
            store.longitude
          )
        ) {
          return;
        }

        const marker =
          new google.maps.Marker({
            map: this.map,

            position: {
              lat: store.latitude,
              lng: store.longitude
            },

            title:
              store.displayName
          });

        marker.addListener(
          'click',
          () => {
            this.selectStore(
              store.storeCode
            );
          }
        );

        this.markers.push(marker);

        bounds.extend(
          marker.getPosition()
        );
      }
    );

    if (this.center) {
      bounds.extend(this.center);
    }

    /*
     * Cuando applyRadius() llama render(false),
     * no dejamos que markers hagan fitBounds.
     * El mapa se ajusta usando fitToRadius()
     * para respetar visualmente 10 / 15 / 20 km.
     */
    if (
      fit &&
      !bounds.isEmpty()
    ) {
      this.map.fitBounds(
        bounds,
        48
      );
    }
  }

  selectStore(code, center = true) {
    this.activeStoreCode = code;

    const store = this.stores.find(
      (item) => item.storeCode === code
    );

    if (!store) return;

    this.renderList();

    if (center) {
      this.map.setCenter({
        lat: store.latitude,
        lng: store.longitude
      });

      this.map.setZoom(13);
    }

    this.listEl
      ?.querySelector(
        `[data-store-code="${CSS.escape(code)}"]`
      )
      ?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
  }

    async chooseStore(code) {
    try {
      await window.ShasaStoreLocator
        .saveFavoriteStore(code);

      this.favoriteStoreCode = code;
      this.activeStoreCode = code;

      this.renderList();

      document.dispatchEvent(
        new CustomEvent(
          'shasa:store-selected',
          {
            detail: {
              storeCode: code
            }
          }
        )
      );
    } catch (error) {
      console.error(
        '[StoreLocatorPage] Could not save favorite store:',
        error
      );

      alert(
        'No pudimos guardar tu tienda. Inténtalo nuevamente.'
      );
    }
  }

  enableMobileSheet() {
    const handle =
      this.root.querySelector(
        '[data-page-handle]'
      );

    if (
      !handle ||
      !this.sheet
    ) {
      return;
    }

    let startY = null;

    handle.addEventListener(
      'pointerdown',
      (event) => {
        startY =
          event.clientY;

        handle.setPointerCapture(
          event.pointerId
        );
      }
    );

    handle.addEventListener(
      'pointerup',
      (event) => {
        if (
          startY === null
        ) {
          return;
        }

        const delta =
          event.clientY -
          startY;

        if (delta < -30) {
          this.sheet.classList.add(
            'is-expanded'
          );
        }

        if (delta > 30) {
          this.sheet.classList.remove(
            'is-expanded'
          );
        }

        startY = null;
      }
    );
  }
}

  document.addEventListener(
  'DOMContentLoaded',
  () => {
    const root =
      document.querySelector(
        '[data-store-page]'
      );

    if (
      root &&
      window.ShasaStoreLocator
    ) {
      new StoreLocatorPage(root);
    }
  }
);
}) ();